export enum PaymentTerm {
    _10d = 1,
    _15d = 2,
    _15d30d = 3,
    _15d30d45d = 4,
    _30d = 5,
    _30d60d = 6,
    _30d60d90d = 7,
    _30d60d90d120d = 8,
    _45d = 9,
    _45d90d = 10,
    _45d90d135d = 11,
    _45d90d135d180d = 12,
    _60d = 13,
    _90d = 14,
    _aVista = 15,
    _aVista15d = 16,
    _aVista15d30d = 17,
    _aVista30d = 18,
    _aVista30d60d = 19,
    _aVista45d = 20,
    _aVista45d90d = 21,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentTerm.ts